export const REPORT_INFO_TYPES = {
  patient: 'patient',
  doctor: 'doctor'
};

export const REPORT_LANGUAGES = [
  {
    key: 'en',
    label: 'English'
  },
  {
    key: 'de',
    label: 'Deutsch'
  }
  // {
  //   key: 'ru',
  //   label: 'Русский'
  // }
];

const REPORT_STATUS_DRAFT = '1';
const REPORT_STATUS_SENT = '2';
const REPORT_STATUS_NEW = '3';

// Legacy GQL numeric statuses — still emitted by the remaining GQL
// consumers (MedicusReports/AppointmentsDetails) until P10.
export const REPORT_STATUSES = {
  draft: REPORT_STATUS_DRAFT,
  sent: REPORT_STATUS_SENT,
  new: REPORT_STATUS_NEW
};

// v2 REST wire statuses (string enum).
export const REPORT_STATUS = {
  draft: 'draft',
  sent: 'sent',
  new: 'new'
} as const;

// Translation-key lookup accepting both wire formats.
export const REPORT_STATUS_VALUES: Record<string, string> = {
  [REPORT_STATUS_DRAFT]: 'draft',
  [REPORT_STATUS_SENT]: 'sent',
  [REPORT_STATUS_NEW]: 'new',
  draft: 'draft',
  sent: 'sent',
  new: 'new'
};

export const REPORT_TYPES = {
  personal: 1,
  medicus: 2
};
